import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import ScrollToTop from '@/components/base/ScrollToTop';
import { CategorySchema } from '@/components/base/SEOSchema';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const categoryArticles = slug ? getArticlesByCategory(slug) : [];

  return (
    <>
      <ScrollToTop />
      {currentCategory && (
        <CategorySchema
          name={currentCategory.name}
          description={currentCategory.description}
          url={`/category/${slug}`}
        />
      )}
      <Navbar />

      <main className="pt-16">
        <div className="max-w-7xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: currentCategory?.name || '分类' },
            ]}
          />
        </div>

        {/* Category Header */}
        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto text-center">
            <h1 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
              {currentCategory?.name || '分类'}
            </h1>
            <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
              {currentCategory?.description || '探索AI风月的精彩内容'}
            </p>
          </div>
        </section>

        {/* Category Tabs */}
        <section className="py-6 px-4 md:px-6 bg-background-50 border-b border-background-200/50 sticky top-16 z-30">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-2 overflow-x-auto flex-wrap pb-1">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap ${
                    slug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-500'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Articles Grid */}
        <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类下暂无文章</p>
              </div>
            )}
          </div>
        </section>

        {/* Back to all categories */}
        <section className="py-10 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto text-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200"
            >
              <i className="ri-arrow-left-line"></i>
              返回首页探索更多AI风月内容
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}